import React, {Component} from 'react';
import {CardBody, CardHeader, CardTitle, Col, Nav, NavItem, NavLink, Row} from 'reactstrap';
import Notify from 'react-notification-alert';
import DocumentViewer from "./component/DocumentViewer"
import DocumentSignatureValidator from "./component/DocumentSignatureValidator"

var base64_arraybuffer = require('base64-arraybuffer')

class SignatureValidator extends Component {

  constructor() {
    super();
    this.state = {
      initialized: false,
      document: null,
      validateOpen: false
    };

    this.init = this.init.bind(this);
    this.validateClicked = this.validateClicked.bind(this);
    this.cleanClicked = this.cleanClicked.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  validateClicked() {
    this.setState({
      validateOpen: true
    });
  }

  cleanClicked() {
    this.setState({
      document: null
    });
  }

  init() {
  }

  render() {
    return <Row className="baseBackground">
      {this.state.alert}
      {<Notify ref={this.notify}/>}
      <DocumentSignatureValidator value={this.state.document} isOpen={this.state.validateOpen} toggle={() => this.setState({validateOpen: false})}/>
      <Col md={12}>
        <Nav className="topbar">
          <NavItem>
            <NavLink href="#" onClick={this.cleanClicked} style={{color: '#fcfdff', fontSize: '13px'}}>
              <img className="simple-text logo-mini" style={{maxWidth: '28px', marginRight: '6px'}} src={process.env.REACT_APP_CONTEXT_NAME + "/image/plus_sign.png"}/>
              Temizle
            </NavLink>
          </NavItem>
          {this.state.document && <NavItem>
            <NavLink href="#" onClick={this.validateClicked} style={{color: '#fcfdff', fontSize: '13px'}}>
              <img className="simple-text logo-mini" style={{maxWidth: '28px', marginRight: '6px'}} src={process.env.REACT_APP_CONTEXT_NAME + "/image/plus_sign.png"}/>
              İmza Doğrula
            </NavLink>
          </NavItem>}
        </Nav>
        <CardHeader style={{marginTop: "56px"}}>
          <CardTitle tag="h4">
            İmza Doğrulama
          </CardTitle>
        </CardHeader>
        <CardBody>
          <DocumentViewer value={this.state.document} onChange={value => {this.setState({document: value})}}/>
        </CardBody>
      </Col>
    </Row>
  }
}

export default SignatureValidator;
